import NotFoundPage from '../screens/404'
import { IRoute } from './navigation.types'
import navigationUtils from './navigation.utils'
import Projects from '../screens/Projects'
import MyTeam from '../screens/Teams/pages/MyTeam'
import Profile from '../screens/Profile'
import MyProject from '../screens/Projects/pages/MyProject'
import UserPage from 'screens/Users/pages/UserPage'
import ProjectPage from 'screens/Projects/pages/ProjectPage'
import UserSKillsPage from 'screens/Admin/UserSkills'
import CreateSkillPage from 'screens/Admin/UserSkills/pages/CreateSkillPage'
import SkillPage from 'screens/Admin/UserSkills/pages/SkillPage'
import OrganizationsPage from 'screens/Admin/Organizations'
import CreateOrganizationPage from 'screens/Admin/Organizations/pages/CreateOrganizationPage'
import OrganizationPage from 'screens/Admin/Organizations/pages/OrganizationPage'
import EventPage from 'screens/Admin/Events/pages/EventPage'
import CreateEventPage from 'screens/Admin/Events/pages/CreateEventPage'
import EventsPage from 'screens/Admin/Events'
import ProjectTechnologiesPage from 'screens/Admin/ProjectTechnologies'
import CreateProjectTechnologyPage from 'screens/Admin/ProjectTechnologies/pages/CreateProjectTechnologyPage'
import ProjectTechnologyPage from 'screens/Admin/ProjectTechnologies/pages/ProjectTechnologyPage'
import CreateProjectPage from 'screens/Projects/pages/CreateProject'
import TeamPage from 'screens/Teams/pages/TeamPage'
import AdminTeamsPage from 'screens/Admin/Teams'
import CreateTeam from 'screens/Admin/Teams/pages/CreateTeam'
import ImportPage from 'screens/Admin/Import'
import UsersAdminPage from 'screens/Admin/Users'
import ExportScreen from 'screens/Admin/Export'
import CreateUserPage from '../screens/Admin/Users/pages/CreateUser'
import ProjectRolesPage from 'screens/Admin/ProjectRoles'
import CreateProjectRolePage from 'screens/Admin/ProjectRoles/pages/CreateProjectRolePage'
import ProjectRolePage from 'screens/Admin/ProjectRoles/pages/ProjectRolePage'
import KnowleageBase from '../screens/Admin/KnowleageBase'
import CreateArticle from 'screens/Admin/KnowleageBase/pages/CreateArticle'
import EditArticle from 'screens/Admin/KnowleageBase/pages/EditArticle'
import ArticleSearchTags from '../screens/Admin/KnowleageBase/pages/ArticleSearchTags'
import KnowleagePage from 'screens/KnowleageBase/pages'
import ProjectTypesPage from 'screens/Admin/ProjectTypes'
import CreateProjectTypePage from 'screens/Admin/ProjectTypes/pages/CreateProjectTypePage'
import ProjectTypePage from 'screens/Admin/ProjectTypes/pages/ProjectTypePage'
import ProjectCheckpointsPage from 'screens/Admin/ProjectCheckpoints/pages'
import CreateCheckpointPage from 'screens/Admin/ProjectCheckpoints/pages/CreateCheckpointPage'
import ProjectCheckpoints from 'screens/ProjectCheckpoints'
import CheckpointPage from 'screens/Admin/ProjectCheckpoints/pages/CheckpointPage'
import ProjectCheckpointPage from 'screens/ProjectCheckpoints/pages/ProjectCheckpointPage'
import CheckpointInspectionPage from 'screens/CheckpointInspection'
import CheckpointInspectionCheckResultsPage from 'screens/CheckpointInspection/pages/CheckpointInspectionCheckResultsPage'
import SubmissionPage from 'screens/CheckpointInspection/pages/SubmissionPage'
import SecurityTemplatesPage from 'screens/Admin/ProtectionTemplates/pages'
import CreateSecurityTemplates from 'screens/Admin/ProtectionTemplates/pages/CreateProtectionTemplates'
import TeamGradeExpertPage from 'screens/Protection/pages/ExpertProtection/TeamGrade'
import ProtectionScheduleAdminPage from 'screens/Protection/pages/AdminProtection/ProtectionSchedule'
import ProtectionRoomsAdminPage from 'screens/Protection/pages/AdminProtection/ProtectionRooms'
import ProtectionGradeAdminPage from 'screens/Protection/pages/AdminProtection/ProtectionGrade'
import ProtectionGradePage from 'screens/Protection/pages/ExpertProtection/ProtectionGrade'
import UpdateProtectionTemplates from 'screens/Admin/ProtectionTemplates/pages/UpdateProtectionTemplate'
import ProtectionTeamPage from 'screens/Protection/pages/UserProtection/Protection'
import ProtectionsPage from 'screens/Protection/pages/UserProtection/Protections'
import ExpertScheduleProtectionPage from 'screens/Protection/pages/ExpertProtection/ExpertProtectionSchedule'

const appRoutes: IRoute[] = [
  {
    path: '*',
    element: <NotFoundPage />,
    permissions: [],
  },
  {
    path: '/projects',
    element: <Projects />,
    permissions: [],
    title: 'каталог',
  },
  {
    path: '/projects/:id',
    element: <ProjectPage />,
    permissions: [],
  },
  {
    path: '/my-project',
    element: <MyProject />,
    permissions: ['ADMIN', 'STUDENT', 'INSPECTOR'],
    title: 'Проект',
  },
  {
    path: '/project-checkpoints',
    element: <ProjectCheckpoints />,
    permissions: ['ADMIN', 'STUDENT', 'INSPECTOR'],
    title: 'Контрольные точки',
  },
  {
    path: '/project-checkpoints/:id',
    element: <ProjectCheckpointPage />,
    permissions: [],
  },
  {
    path: '/checkpoint-inspection',
    element: <CheckpointInspectionPage />,
    permissions: ['admin', 'INSPECTOR'],
    title: 'Проверка контрольных точек',
  },
  {
    path: '/checkpoint-inspection/:id',
    element: <CheckpointInspectionCheckResultsPage />,
    permissions: ['admin', 'EXPERT', 'INSPECTOR'],
  },
  {
    path: '/checkpoint-inspection/:checkpointId/submission/:resultId',
    element: <SubmissionPage />,
    permissions: ['admin', 'EXPERT', 'INSPECTOR'],
  },
  {
    path: '/my-team',
    element: <MyTeam />,
    permissions: ['ADMIN', 'STUDENT', 'INSPECTOR'],
    title: 'Команда',
  },
  {
    path: '/protections',
    element: <ProtectionsPage />,
    permissions: ['STUDENT'],
    title: 'Защита',
  },
  {
    path: '/protections/:id/team/:teamId',
    element: <ProtectionTeamPage />,
    permissions: ['STUDENT'],
  },
  {
    path: '/knowledge-base',
    element: <KnowleagePage />,
    permissions: ['ADMIN'],
    title: 'База знаний',
  },
  {
    path: '/profile',
    element: <Profile />,
    permissions: [],
    title: 'Профиль',
  },
  {
    path: '/protection-schedule',
    element: <ExpertScheduleProtectionPage />,
    permissions: ['EXPERT'],
    title: 'Защита',
  },
  {
    path: '/protection-schedule/:id',
    element: <ProtectionGradePage />,
    permissions: ['EXPERT'],
  },
  {
    path: '/protection-schedule/:id/:teamId',
    element: <TeamGradeExpertPage />,
    permissions: ['EXPERT'],
  },
  {
    path: '/admin/protection-admin',
    element: <ProtectionScheduleAdminPage />,
    permissions: ['ADMIN'],
  },
  {
    path: '/admin/protection-grade',
    element: <ProtectionGradeAdminPage />,
    permissions: ['ADMIN'],
  },
  {
    path: '/admin/protection-admin/:id',
    element: <ProtectionRoomsAdminPage />,
    permissions: ['ADMIN'],
  },
  {
    path: '/admin/skills',
    element: <UserSKillsPage />,
    permissions: ['admin'],
    title: 'Администрирование',
  },
  {
    path: '/admin/skills/create',
    element: <CreateSkillPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/skills/:id',
    element: <SkillPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/organizations',
    element: <OrganizationsPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/organizations/create',
    element: <CreateOrganizationPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/organizations/:id',
    element: <OrganizationPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/knowledge-base',
    element: <KnowleageBase />,
    permissions: ['admin'],
  },
  {
    path: '/admin/knowledge-base/articles/create',
    element: <CreateArticle />,
    permissions: ['admin'],
  },
  {
    path: '/admin/knowledge-base/articles/edit/:id',
    element: <EditArticle />,
    permissions: ['admin'],
  },
  {
    path: '/admin/knowledge-base/search-tags',
    element: <ArticleSearchTags />,
    permissions: ['admin'],
  },
  {
    path: '/admin/events',
    element: <EventsPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/events/create',
    element: <CreateEventPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/events/:id',
    element: <EventPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-technologies',
    element: <ProjectTechnologiesPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-technologies/create',
    element: <CreateProjectTechnologyPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-technologies/:id',
    element: <ProjectTechnologyPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-checkpoints/create',
    element: <CreateCheckpointPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-checkpoints',
    element: <ProjectCheckpointsPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-checkpoints/:id',
    element: <CheckpointPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-types/create',
    element: <CreateProjectTypePage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-types/:id',
    element: <ProjectTypePage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-types',
    element: <ProjectTypesPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/protection-templates',
    element: <SecurityTemplatesPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/protection-templates/create',
    element: <CreateSecurityTemplates />,
    permissions: ['admin'],
  },
  {
    path: '/admin/protection-templates/:id',
    element: <UpdateProtectionTemplates />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-roles',
    element: <ProjectRolesPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-roles/create',
    element: <CreateProjectRolePage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/project-roles/:id',
    element: <ProjectRolePage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/teams',
    element: <AdminTeamsPage />,
    permissions: ['admin'],
  },
  {
    path: '/users/:id',
    element: <UserPage />,
    permissions: [],
  },
  {
    path: '/admin/users/create',
    element: <CreateUserPage />,
    permissions: ['admin'],
  },
  {
    path: '/projects/create',
    element: <CreateProjectPage />,
    permissions: ['admin'],
  },
  {
    path: '/teams/:id',
    element: <TeamPage />,
    permissions: [],
  },
  {
    path: '/admin/teams/create',
    element: <CreateTeam />,
    permissions: ['admin'],
  },
  {
    path: '/admin/import',
    element: <ImportPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/users',
    element: <UsersAdminPage />,
    permissions: ['admin'],
  },
  {
    path: '/admin/export',
    element: <ExportScreen />,
    permissions: ['admin'],
  },
]

navigationUtils.makeRoutePagesProtected(appRoutes)
export default appRoutes
